import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'
const apiUrl = `${urlPrefix}/UnitArchaeology`
//#region 基本信息
const GetList = (id: number) => `${apiUrl}/GetList/${id}`
const GetInfo = (id: number) => `${apiUrl}/${id}`
const PostData = `${apiUrl}`
const PutData = (id: number) => `${apiUrl}/${id}`
const Delete = (id: number) => `${apiUrl}/${id}`
//#endregion
export const emptyData: UnitArchaeologyData = {
    Id: 0,
    UnitId: 0,
    IsInvestigation: false,
    InvestigationYear: 0,
    InvestigationMonth: 0,
    InvestigationDocId: 0,
    InvestigationArea: 0,
    InvestigationLocation: '',
    InvestigationCoords: '',
    InvestigationUnit: '',
    InvestigationCategory: 0,
    InvestigationDescription: '',
    InvestigationFundSoruceCountry: false,
    InvestigationFundSoruceProvince: false,
    InvestigationFundSoruceSelf: false,
    InvestigationFundAmount: 0,
    IsExploration: false,
    ExplorationYear: 0,
    ExplorationMonth: 0,
    ExplorationDocId: 0,
    ExplorationArea: 0,
    ExplorationLocation: '',
    ExplorationCoords: '',
    ExplorationUnit: '',
    ExplorationDescription: '',
    ExplorationFundSoruceCountry: false,
    ExplorationFundSoruceProvince: false,
    ExplorationFundSoruceSelf: false,
    ExplorationFundAmount: 0,
    IsDig: false,
    DigYear: 0,
    DigMonth: 0,
    DigDocId: 0,
    DigUnit: '',
    DigDescription: '',
    DigArea: 0,
    DigLocation: '',
    DigCoords: '',
    DigFundSoruceCountry: false,
    DigFundSoruceProvince: false,
    DigFundSoruceSelf: false,
    DigFundAmount: 0,
    Location: '',
    Coords: '',
    CurrentAddress: '',
    WorkResult: '',
    Status: 0,
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),

    InvestigationCategoryName: '',
    InvestigationDocNo: '',
    ExplorationDocNo: '',
    DigDocNo: '',
    UserName: '',

    AttachTypeIstRecord: 0,
    AttachGuidIstRecord: '',
    AttachTypeIstSpecimen: 0,
    AttachGuidIstSpecimen: '',
    AttachTypeIstDrawing: 0,
    AttachGuidIstDrawing: '',
    AttachTypeIstPicture: 0,
    AttachGuidIstPicture: '',

    AttachTypeExpRecord: 0,
    AttachGuidExpRecord: '',
    AttachTypeExpSmallPiece: 0,
    AttachGuidExpSmallPiece: '',
    AttachTypeExpDrawing: 0,
    AttachGuidExpDrawing: '',
    AttachTypeExpPicture: 0,
    AttachGuidExpPicture: '',

    AttachTypeDigRecord: 0,
    AttachGuidDigRecord: '',
    AttachTypeDigSmallPiece: 0,
    AttachGuidDigSmallPiece: '',
    AttachTypeDigDrawing: 0,
    AttachGuidDigDrawing: '',
    AttachTypeDigPicture: 0,
    AttachGuidDigPicture: ''
}
export interface UnitArchaeologyData {
    [key: string]: any
    Id: number
    UnitId: number
    IsInvestigation: boolean
    InvestigationYear: number
    InvestigationMonth: number
    InvestigationDocId: number
    InvestigationArea: number
    InvestigationLocation: string
    InvestigationCoords: string
    InvestigationUnit: string
    InvestigationCategory: number
    InvestigationDescription: string
    InvestigationFundSoruceCountry: boolean
    InvestigationFundSoruceProvince: boolean
    InvestigationFundSoruceSelf: boolean
    InvestigationFundAmount: number
    IsExploration: boolean
    ExplorationYear: number
    ExplorationMonth: number
    ExplorationDocId: number
    ExplorationArea: number
    ExplorationLocation: string
    ExplorationCoords: string
    ExplorationUnit: string
    ExplorationDescription: string
    ExplorationFundSoruceCountry: boolean
    ExplorationFundSoruceProvince: boolean
    ExplorationFundSoruceSelf: boolean
    ExplorationFundAmount: number
    IsDig: boolean
    DigYear: number
    DigMonth: number
    DigDocId: number
    DigUnit: string
    DigDescription: string
    DigArea: number
    DigLocation: string
    DigCoords: string
    DigFundSoruceCountry: boolean
    DigFundSoruceProvince: boolean
    DigFundSoruceSelf: boolean
    DigFundAmount: number
    Location: string
    Coords: string
    CurrentAddress: string
    WorkResult: string
    Status: number
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date

    InvestigationCategoryName: string
    InvestigationDocNo: string
    ExplorationDocNo: string
    DigDocNo: string
    UserName: string

    AttachTypeIstRecord: number
    AttachGuidIstRecord: string
    AttachTypeIstSpecimen: number
    AttachGuidIstSpecimen: string
    AttachTypeIstDrawing: number
    AttachGuidIstDrawing: string
    AttachTypeIstPicture: number
    AttachGuidIstPicture: string

    AttachTypeExpRecord: number
    AttachGuidExpRecord: string
    AttachTypeExpSmallPiece: number
    AttachGuidExpSmallPiece: string
    AttachTypeExpDrawing: number
    AttachGuidExpDrawing: string
    AttachTypeExpPicture: number
    AttachGuidExpPicture: string

    AttachTypeDigRecord: number
    AttachGuidDigRecord: string
    AttachTypeDigSmallPiece: number
    AttachGuidDigSmallPiece: string
    AttachTypeDigDrawing: number
    AttachGuidDigDrawing: string
    AttachTypeDigPicture: number
    AttachGuidDigPicture: string
}
export const getInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetInfo(id),
    })
}
export const getList = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetList(id),
    })
}
export const postData = (form: UnitArchaeologyData) => {
    return tryAxios({
        method: 'post',
        url: PostData,
        data: form
    })
}
export const putData = (id: number, form: UnitArchaeologyData) => {
    return tryAxios({
        method: 'put',
        url: PutData(id),
        data: form
    })
}
export const removeData = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}
